import React from 'react';
import { roles } from '@nxsys/store/constants';

const EmployeeOnboarding = React.lazy(
  () => import('../../../modules/onboarding/EmployeeOnboarding'),
);

export const onboardingConfig = [
  {
    // Employees complete their own onboarding here. The admin equivalent lives
    // in the prospect listing (ViewOnboardingModal).
    permittedRole: [roles.employee],
    path: '/onboarding',
    element: <EmployeeOnboarding />,
  },
];
